/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const PointerUpIcon = /*#__PURE__*/ createSvgIcon(
  'PointerUpIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9 1.5a1.13 1.13 0 00-1.123 1.255.501.501 0 01.003.055V8.5a.5.5 0 11-1 0c0-1.091-.346-1.485-.64-1.653-.347-.198-.805-.194-1.228-.15a16.93 16.93 0 00-3.154.78A1.8 1.8 0 002.5 9.39v4c0 .444.003.758.165 1.152.166.406.52.936 1.308 1.725a.5.5 0 01.147.353v1.88h7.09v-1.02c0-.855.25-1.539.767-2.11.496-.546 1.21-.958 2.073-1.344l4.39-2.083a1.147 1.147 0 00-.234-.402c-.262-.288-.898-.67-2.49-.332-.42.094-1.186.277-1.852.438-.333.08-.64.155-.862.21l-.363.088-.12-.485.12.485a.5.5 0 01-.62-.485V2.81h.5l-.496-.055A1.128 1.128 0 0010.9 1.5zm2.12 1.336a2.128 2.128 0 00-2.99-2.15 2.13 2.13 0 00-1.25 2.15v3.233a2.03 2.03 0 00-.145-.09c-.65-.372-1.403-.322-1.837-.276a17.93 17.93 0 00-3.345.823A2.8 2.8 0 001.5 9.41v4c0 .44 0 .926.24 1.511.224.546.64 1.144 1.38 1.904V19a.5.5 0 00.5.5h8.09a.5.5 0 00.5-.5v-1.52c0-.635.175-1.07.508-1.438.353-.39.912-.733 1.746-1.106l4.75-2.254a.5.5 0 00.286-.452H19h.5V12.212a1.38 1.38 0 00-.01-.132 2.164 2.164 0 00-.544-1.211c-.586-.646-1.644-1.02-3.44-.638l-.005.001c-.43.096-1.207.282-1.872.443l-.61.148V2.836z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default PointerUpIcon;
